import styled from "styled-components";

export const PeopleCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  width: 100%;
  gap: 16px;
`;

export const PeopleListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  flex: 1;
  width: 100%;
`;

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    color: ${({ theme }) => theme.border.black50};
  }

  a {
    color: ${({ theme }) => theme.text.brand};
    text-decoration: none;
  }
`;
